'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PlayerHeader = require('./PlayerHeader.css');

var _PlayerHeader2 = _interopRequireDefault(_PlayerHeader);

var _ResponsivePNG = require('../ResponsivePNG/ResponsivePNG');

var _ResponsivePNG2 = _interopRequireDefault(_ResponsivePNG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayerHeader = function PlayerHeader(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _PlayerHeader2.default.__scopedHash + ' ' + 'header'
    },
    _react2.default.createElement(_ResponsivePNG2.default, { className: 'headshot', style: _PlayerHeader.headshotCss, src: props.headshotUrl, alt: '' }),
    _react2.default.createElement(
      'span',
      {
        className: 'jsx-' + _PlayerHeader2.default.__scopedHash + ' ' + 'name'
      },
      props.name
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _PlayerHeader2.default.__scopedHash,
      css: _PlayerHeader2.default.__scoped
    })
  );
};

PlayerHeader.propTypes = {
  headshotUrl: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired
};

exports.default = PlayerHeader;